import { useCallback } from "react";
import { generateMockMatterTaskPayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterTask } from "@/lib/data/react-query/matters/matter-task";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterTask = () => {
  const createTask = useCreateMatterTask();

  const createMockMatterTask = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) => {
      return createMultiple(count, () =>
        createTask.mutateAsync({
          ...generateMockMatterTaskPayload(matterId, overrides),
        }),
      );
    },
    [createTask],
  );

  return {
    createMockMatterTask,
    mutation: createTask,
  };
};
